import { configureStore } from "@reduxjs/toolkit";
import reloadsReducer from "./reloads/reloadsReducer";
import listPageReducer from "./listPage/listPageReducer";
export const store = configureStore({
    reducer: {
        reloads: reloadsReducer,
        listPage: listPageReducer,
    },
});
